"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setScatterPlotUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketHelper_1 = require("./../bucketHelper");
// If you need to edit these icons
// reflect changes also in gdc-analytical-designer
// https://github.com/gooddata/gdc-analytical-designer/blob/develop/app/components/buckets/BucketIcon.tsx
var scatterMeasuresXIcon = "local:scatter/bucket-title-measures-x.svg";
var scatterMeasuresYIcon = "local:scatter/bucket-title-measures-y.svg";
var scatterAttributeIcon = "local:scatter/bucket-title-attribute.svg";
function setScatterPlotUiConfig(referencePoint, intl, visualizationType) {
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], scatterMeasuresXIcon);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.SECONDARY_MEASURES, "icon"], scatterMeasuresYIcon);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.ATTRIBUTE, "icon"], scatterAttributeIcon);
    return referencePointConfigured;
}
exports.setScatterPlotUiConfig = setScatterPlotUiConfig;
//# sourceMappingURL=scatterPlotUiConfigHelper.js.map